(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-customer-viewing"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.productView-ViewingProduct');
    const numberEl = container.querySelector('.productView-ViewingProduct .text b');

    // Get values from HTML attributes
    const viewNumbers = container.dataset.customerView.split(',').map(n => n.trim());
    const delaySeconds = parseInt(container.dataset.customerViewTime || '5');
    const delay = delaySeconds * 1000;

    let index = 0;

    function showNextNumber() {
      numberEl.textContent = viewNumbers[index];
      index = (index + 1) % viewNumbers.length;
      setTimeout(showNextNumber, delay);
    }

    showNextNumber(); // Start loop
  });
  } catch(e) { console.error(e); }
})();

})();
